export function getSubtotalKey(dimensions) {
    return dimensions.join(':');
}
//# sourceMappingURL=subtotals.js.map